import React from 'react'
import { useModal } from '../contexts/ModalContext'
import FormularioRD from '../rdstation/formularioRD'
import { cn } from '../utils/cn'
import Container from './container'

export default function BusinessOtimize({
  backgroundImage = '',
  bgMobile = '',
  title = '',
  buttonText = '',
  buttonLink = '',
}) {
  const { openModal } = useModal()
  return (
    <div
      className={cn(
        `w-full bg-cover flex items-center justify-center overflow-hidden bg-[rgba(4,1,22,1)] bg-[url(${bgMobile})] lg:bg-[url(${backgroundImage})] bg-no-repeat`,
        backgroundImage === '../assets/banner-erp-otimize.png'
          ? 'bg-top'
          : 'bg-center',
      )}
    >
      <Container className="text-center py-18 lg:py-24">
        {/* Título com texto personalizado */}
        <div className="text-white text-2xl md:text-4xl xl:text-[40px] font-inter-light mx-auto mb-16 md:leading-14 tracking-wide">
          {title}
        </div>

        {/* Botão com fundo branco e texto com gradiente */}
        <button
          type="button"
          onClick={() => openModal(<FormularioRD />)}
          className="inline-block py-2.5 px-5 md:px-8 md:py-3 bg-white rounded-full hover:scale-105 transition-all duration-300 cursor-pointer"
        >
          <span
            className={cn(
              'font-inter-medium text-lg md:text-2xl text-[#A800E4]',
            )}
          >
            {buttonText}
          </span>
        </button>
      </Container>
    </div>
  )
}
